module.exports = "<h3 ng-transclude></h3>";